export const list = {
  table: {
    id: 'ID',
    name: 'Name',
    price: 'Price',
    netWeightG: 'Content weight (g)',
    netWeightMl: 'Content weight (ml)',
    specificGravity: 'Specific gravity',
    costPerMl: 'Cost per ml',
    remainingQuantity: 'Remaining quantity',
    thresholdQuantity: 'Threshold quantity',
    g: 'g',
    ml: 'ml',
    bin: 'bin',
    importGoods: 'Import goods',
  },
  buttonAction: {
    importAdd: 'Import (Add)',
    importOverwrite: 'import (Overwrite)',
    export: 'Export',
    update: 'Update',
  },
  pageHeader: {
    title: 'Detergent',
    titleDetergentsList: 'Personal data registration/editing',
    new: 'New',
  },
}
